/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sidebar_Company_TermsInputs */

const en_admin_sidebar_company_terms = /** @type {(inputs: Admin_Sidebar_Company_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company terms`)
};

const de_admin_sidebar_company_terms = /** @type {(inputs: Admin_Sidebar_Company_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmens-AGB`)
};

/**
* | output |
* | --- |
* | "Company terms" |
*
* @param {Admin_Sidebar_Company_TermsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_sidebar_company_terms = /** @type {((inputs?: Admin_Sidebar_Company_TermsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sidebar_Company_TermsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_sidebar_company_terms(inputs)
	return en_admin_sidebar_company_terms(inputs)
});